<nav class="activites-header fixed-top">
    <div class="h-100 row m-0 d-flex flex-nowrap justify-content-between">
        <div class="w-50 header-left-section d-flex flex-row">
            <div class="px-3 d-flex justify-content-center" *ngIf="!hideArrow">
                <div (click)="activityService.backNavigation()"
                    class="icon-cursor d-flex align-items-center activity-description-bold">
                    <mat-icon class="mat-icon-color back-arrow-button">arrow_back_ios</mat-icon>
                </div>
            </div>
            <div class="logo" *ngIf="logoImg" (click)="navigate()">
                <img [src]="logoImg" alt="Logo" onerror="this.src='./assets/images/noLogoFound.png'" (error)="activityService.errorImageHandler($event)"/>
            </div>
        </div>
        <div class="w-50 header-right-section">
            <div [hidden]="!showTimer">
                <div class="me-2 d-flex flex-wrap align-items-center justify-content-center">
                    <cd-timer #cdTimer (onComplete)="onTimerComplete($event)" countdown="true" [startTime]="activityService.ConfigSettings.bookingSessionTime"
                        format="intelli">
                    </cd-timer>
                    <div class="ms-md-3 time-left-text text-truncate">{{'leftForBooking' | translate}}</div>
                </div>
            </div>
            <!-- Enable when using cart functionality -->
            <div *ngIf="!hideCart" class="cart-logo me-4" (click)="cartProceed()">
                <div class="position-relative">
                    <i class="material-icons icon icon-cursor">
                        <mat-icon matTooltip="{{'cartIcon'| translate}}">shopping_cart</mat-icon>
                    </i>
                    <span class="position-absolute badge rounded-pill cart-count">
                        {{activityService.cartCount | number}}
                    </span>
                </div>
            </div> 
            <div class="lang-dropdown" [hidden]="!IsMultiLanguageSelectionEnabled"  *ngIf="activityService.showLanguageOption" style="  display: flex;">
                <dynamic-form [config]="languageConfig"></dynamic-form>
            </div>
        </div>
    </div>
</nav>